import { LoadingPage } from '@act/storybook';
import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ReportViewToolbar } from '../components/ReportViewToolbar';
import { useReportReadingPageData } from '../hooks/useReportReadingPageData.hook';
import ReportReadingColumn from '../preview/ReportReadingColumn';

const REPORTS_VIEW_BODY_CLASS = 'reports-view-active';
const REPORTS_VIEW_HTML_CLASS = 'reports-view-active-html';

/**
 * Full-page read-only report view with scroll-reveal animations enabled.
 */
const ReportViewPage = () => {
  const { reportId = '' } = useParams<{ reportId: string }>();

  const {
    report,
    customer,
    reportLoading,
    reportError,
    readingItems,
    cadence,
    measurementPeriod,
    isReady,
  } = useReportReadingPageData(reportId);

  useEffect(() => {
    document.documentElement.classList.add(REPORTS_VIEW_HTML_CLASS);
    document.body.classList.add(REPORTS_VIEW_BODY_CLASS);
    return () => {
      document.documentElement.classList.remove(REPORTS_VIEW_HTML_CLASS);
      document.body.classList.remove(REPORTS_VIEW_BODY_CLASS);
    };
  }, []);

  if (!reportLoading && !report && reportError) {
    return (
      <div className="reports-view-page">
        <Typography variant="h6">Report not found</Typography>
        <Link to="/">Back to reports</Link>
      </div>
    );
  }

  if (!isReady || !report || !customer) {
    return <LoadingPage />;
  }

  return (
    <div className="reports-view-page">
      <ReportViewToolbar reportId={reportId} />

      <div className="reports-print-document-stage">
        <div className="reports-print-document-window">
          <ReportReadingColumn
            customer={customer}
            reportingPeriod={report.reportingPeriod}
            measurementPeriod={measurementPeriod}
            cadence={cadence}
            items={readingItems}
            mode="preview"
            reportId={reportId}
          />
        </div>
      </div>
    </div>
  );
};

export default ReportViewPage;
